import './exportable_chart.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.TagsView extends Monitoring.Reports.Campaign.ExportableChart
  include @, Monitoring.Reports.Campaign.Utils

  className: 'tags'

  initialize: (@options = {}) =>
    @className = "contents-by-tags" if @options.contentsByTag
    @top = false

  render: ->
    @$el.addClass('processing')

    params = @paramsForChildsOfPosts
      date_from_ISO: @options.date_from_ISO
      date_to_ISO: @options.date_to_ISO
      exclude_page_owner_generated: true

    if @options.contentsByTag
      $.post('/monitoring/reports/campaign/tags_contents_count_level_zero', params, @_renderChart)
    else
      $.post('/monitoring/dashboard/charts/hierarchy', params, @_renderChart)

  _renderChart: (data) =>
    @$el.removeClass('processing')
    @_renderColumns(data)


    @trigger('rendered')

  _renderColumns: (data) ->
    if @series == undefined
      if @options.contentsByTag
        @series = @_columnsSeries(data)
      else
        @series = @_columnsSeries(data.levels[0])
    series = if @top then @sortAndTruncateSerie(@series, @options.topTags) else @series
      
    @$el.highcharts(@chartOptions(series))

  sortAndTruncateSerie: (collection, taken) =>      
    series = collection.sort (a,b) ->
      sortBy(a, b)
    series.slice(0,taken)

  sortBy = (a, b) ->
    if a.data[0] > b.data[0] 
      return -1 
    else
      1

  _columnsSeries: (data) =>
    totalCount = 0
    for tag in data when tag.y != 0
      totalCount += tag.y

    percentage= 0
    for tag in data when tag.y != 0
      percentage = Number((tag.y/totalCount) * 100).toFixed(2)
      tag.name += " (" + percentage + "%)" if percentage > 0
    series = for tag in data when tag.y != 0
      {
        name: tag.name,
        data: [tag.y]
      }
    return series

  _pieSeries: (data) =>
    seriesData = for tag in data when tag.y != 0
      tag
    series = [
      {
        name: 'Tags'
        data: seriesData
      }
    ]
    return series

  updateTop: =>
    @top = !@top

  chartOptions: (series) =>
    options = {
      chart:
        type: 'column'
        backgroundColor: "#FFFFFF"
        height: 380
        style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}
      title: null
      plotOptions:
        column:
          dataLabels:
            enabled: true
      xAxis:
        categories: ['']
      yAxis:
        title:
          text: null
      tooltip:
        useHTML: true
      legend:
        align: 'right'
        layout: 'vertical'
        verticalAlign: 'middle'
        floating: false
      series: series
      exporting:
        chartOptions:
          title: null 
        buttons:
          contextButton:
            menuItems: []
    }
    
    menuItems = Highcharts.getOptions().exporting.buttons.contextButton.menuItems
    menuItems = menuItems.concat({separator:true})
    menuItems = menuItems.concat({
      text: if @top then 'Show all' else 'Show top tags'
      onclick: => 
        @updateChart()
    })
    menuItems = menuItems.concat(@exportingOptions)
    options.exporting.buttons.contextButton.menuItems = menuItems

    options

  updateChart: =>
    @updateTop()
    if @series.length > @options.topTags
      @$el.highcharts().destroy()
      @_renderColumns({})
